export default [
  {
    path: 'escalas',
    name: 'Escalas',
    component: () => import('./ScaleList.vue'),
    meta: {
      pageSection: 'Funcionários',
      pageTitle: 'Escalas',
    },
  },
]
